import { api_get, api_put } from '@lf/api-client/lfApi';

export async function getEmailSubscription(childProfileId, setError = null) {
  const response = await api_get(
    `/email/subscription/${childProfileId}`,
    undefined,
    setError,
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
}

export async function updateEmailSubscription(childProfileId, prefs, setError = null) {
  const response = await api_put(
    `/email/subscription/${childProfileId}`,
    prefs,
    setError,
  );
  if (response && response.status === 200) {
    return response.data;
  }
  return null;
}
